import { Collapse } from "@mui/material";
import { useContext } from "react";

import Context from "../../../../../context";
import CustomValueInputsRow from "./CustomValueInputsRow";

// ----------------------------------------------------------------------
type Props = {
	id: string;
};

export const CustomValueRow = ({ id }: Props) => {
	const { state } = useContext(Context);

	const positionSelected = state.selectedPositions.find((i) => i.id === id);
	const shares = positionSelected?.shares;
	const show = shares !== undefined || shares === null;

	return (
		<Collapse in={show}>
			<CustomValueInputsRow id={id} />
		</Collapse>
	);
};

export default CustomValueRow;
